var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.block)?_c('div',[_c('view-block',{key:'footer' + _vm.trigger,attrs:{"block":_vm.block,"elements":_vm.elements}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }